<template>
  <div class="inline-flex items-center">
    <Check
      v-if="status === 'SEND' || status === 'SENT'"
      :size="16"
      :stroke-width="2.5"
      class="text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
    />
    <CheckCheck
      v-else-if="status === 'DELIVERED'"
      :size="16"
      :stroke-width="2.5"
      class="text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
    />
    <CheckCheck
      v-else-if="status === 'READ'"
      :size="16"
      :stroke-width="2.5"
      class="text-blue-500 dark:text-blue-400"
    />
    <button
      v-else-if="status === 'FAILED'"
      v-tooltip.top="failureText || t('whatsapp.message_not_delivered')"
      type="button"
      class="inline-flex cursor-pointer"
      @click.stop="emit('show-failure')"
    >
      <X :size="16" :stroke-width="2.5" class="text-red-500 dark:text-red-400" />
    </button>
    <Clock
      v-else
      :size="16"
      :stroke-width="2.5"
      class="text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
    />
  </div>
</template>

<script setup lang="ts">
import { Check, CheckCheck, X, Clock } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import type { MessageStatus } from '../../types/enums'

interface Props {
  status?:
    | MessageStatus
    | 'SEND'
    | 'SENT'
    | 'DELIVERED'
    | 'READ'
    | 'FAILED'
    | 'PENDING'
    | 'ENQUEUED'
  sent?: boolean
  // Código, motivo de Meta y explicación cuando el mensaje falló; va en el tooltip.
  failureText?: string
}

withDefaults(defineProps<Props>(), {
  status: 'PENDING',
  sent: false,
  failureText: '',
})

// La X roja abre el detalle del fallo; quien la usa decide qué mostrar.
const emit = defineEmits<{ (e: 'show-failure'): void }>()

const { t } = useI18n()
</script>
